import React from "react";

export const ReconGlobalContext = React.createContext();

const ReconGlobalProvider = ({kxUser={}, children}) => {
    const values=React.useMemo(()=>{
        return {kxUser}
    },[kxUser])

    return ( 
        <ReconGlobalContext.Provider value={values}>
            {children}
        </ReconGlobalContext.Provider>
     );
}
 
export default ReconGlobalProvider;